import { React, useState } from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard';
import BarChartIcon from '@material-ui/icons/BarChart';
import ListItemButton from '@mui/material/ListItemButton';
import ListSubheader from '@mui/material/ListSubheader';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useNavigate } from 'react-router-dom';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Cookies from 'universal-cookie';
import Swal from "sweetalert2";
import { Report } from '@material-ui/icons';

import buscar from '../pages/Cuenta.js';
import axios from 'axios';

const baseUrl = "http://154.85.2.66:9095/api/personas";
const UrlNotarias = "http://154.85.2.66:9095/api/notarias";
const UrlAuditorias = "http://154.85.2.66:9095/api/auditorias";


const cookies = new Cookies();
export const MainListItems = (props) => {
    const cookies = new Cookies();
    const [user1, setUser1] = useState(cookies.get('NOMBRE'));
    const [dni1, setDni1] = useState(cookies.get('CLAVE'));
    const [cont1, setCont1] = useState(cookies.get('CONTRIBUYENTE'));
    
    
    const [data, setData] = useState([]);
    var user = '';

    const [form, setForm] = useState({
        dni: dni1,//dni inicializada con el coockie guardado
        nombre: user1,//nombre inicializada con el coockie guardado
        contribuyente: cont1//contribuyente inicializada con el coockie guardado
    });

    const handleChange = e => {
        const { name, value } = e.target;
        setForm({
            ...form,
            [name]: value
        });
        console.log(name);

    }
    const audit = (persona, carpeta, generador) => {
        axios.post(UrlAuditorias, {
            CONTRIBUYENTE: persona,
            PREDIO: carpeta,
            GENERADOR: generador,
            USUARIO: cookies.get('id')
        }
        )
    }

    const redirectToExternalLink = () => {
        // Reemplaza la URL "https://www.ejemplo.com" con la dirección externa que deseas redirigir.
        window.location.href = "http://munisantiago.gob.pe/publicacion/home/inicio.php";
    };

    const cerrarSesion = () => {
        // console.log(cookies.get('id'));
        // console.log(props)

        cookies.remove('id', { path: '/' });

        cookies.remove('CONTRIBUYENTE', { path: '/' });
        cookies.remove('CLAVE', { path: '/' });
        cookies.remove('NOMBRE', { path: '/' });
        setCont1('')
        setDni1('')
        setUser1('')


        navigate("/login2")
        Swal.fire(
            'SESIÓN CERRADA',
            '',
            'error'
        );
    }
    const navigate = useNavigate();
    // const f2 = buscar(form.nombre, form.contribuyente)
{/* const h2 = buscar(form.nombre, form.contribuyente) */}

            {/* onChange={(e) => buscar(form.nombre, form.contribuyente)} */}
    return (
        <div>
            <ListItem button onClick={() => { navigate("/dashboard2") }}>
                <ListItemIcon>
                    <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Estadisticas" />
            </ListItem>
            <ListItem button onClick={() => {navigate("/cuenta")}}>
            
                <ListItemIcon>
                    <BarChartIcon />
                </ListItemIcon>
                <ListItemText primary="Constancia" />
            </ListItem>

                        
            <ListItem button onClick={redirectToExternalLink}>
                <ListItemIcon>
                    <Report />
                </ListItemIcon>
                <ListItemText primary="Estado Cuenta" />
            </ListItem>

            <ListItem button onClick={() => { navigate("/login2") }}>
                <ListItemIcon>
                    <ExitToAppIcon onClick={() => cerrarSesion()} />
                </ListItemIcon>
                <ListItemText primary="" />
            </ListItem>
        </div>
    );


}

export const secondaryListItems = (
    <><ListSubheader component="div" inset>
        Saved reports
    </ListSubheader><ListItemButton>
            <ListItemIcon>
                <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="Current month" />
        </ListItemButton><ListItemButton>
            <ListItemIcon>
                <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="Last quarter" />
        </ListItemButton><ListItemButton>
            <ListItemIcon>
                <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="Year-end sale" />
        </ListItemButton></>
);


